<template>
  <div id="app" class="container">
  	<h1>Netherlandish Woodcuts</h1>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

/* Voorkom verspringen scherm bij openen popup (door verdwijnen vert scrollbar) */
.modal {
 overflow-y: auto !important;
}

.modal-open {
 overflow: auto  !important;
}

</style>



// WEBPACK FOOTER //
// App.vue?21ba0cea